module.exports = __webpack_public_path__ + "static/media/Instagram.1c766f58.svg";